<img
  class="compass"
  [ngStyle]="{ transform: 'rotate(' + yaw + 'deg)' }"
  src="assets/images/compass-icon.svg"
  alt="compass"
  width="140"
  height="140"
/>
